import React from 'react'
import {connect, store} from 'react-redux'
import {withRouter} from "react-router-dom";
import ReactSVG from 'react-svg'
import log from 'components/utils/Logger'
import queryString from 'query-string';
import moment from 'moment';
import * as url from 'constants/Api'
import 'moment/locale/ja';
import {Icon} from 'antd';
import * as Actions from 'redux/actions'
import * as GlobalConfig from "../../../constants/GlobalConfig";
import Header from "../../header/Header";
import {CSSTransitionGroup} from 'react-transition-group'
import NotificationBanner from "../../../components/NotificationBanner";
import IntervalTimer from "react-interval-timer";


moment.locale('ja');


const mapStateToProps = (state, props) => {
    return {
        mapStatus: state.mapStatus,
        mapLabels: state.mapLabels,
        stockStatus: state.stockStatus,
        mapStatusConnection: state.mapStatusConnection
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getStatus: () => {
            dispatch(Actions.http.connection.mapStatus.get())
        }
    }
}

class Map extends React.Component {
    constructor(props) {
        super(props);

        //追加 1
        const query = queryString.parse(this.props.location.search);
        let map_id = "1";
        if (query.map_id) {
            if (query.map_id !== "1" && query.map_id !== "2" && query.map_id !== "3" && query.map_id !== "4" && query.map_id !== "5" && query.map_id !== "7") {
                this.props.history.push(`${process.env.PUBLIC_URL}/?map_id=1`);
            } else {
                map_id = query.map_id;
            }
        } else {
            this.props.history.push(`${process.env.PUBLIC_URL}/?map_id=1`);
        }
        //追加 1
        let calcWidth = window.innerWidth;
        let calcHeight = window.innerHeight - 100;
        let floorPath = "";
        let title = "";

        //追加 2
        switch (map_id) {
            case "1":
            case 1:
                floorPath = process.env.PUBLIC_URL + '/svg/daikoudai/oit_building5_5f.svg';
                title = (
                    <h1>ラーニングコモンズ1,2,3,4,5</h1>
                );
                break;
            case "2":
            case 2:
                floorPath = process.env.PUBLIC_URL + '/svg/daikoudai/oit_building5_7fa.svg';
                title = (
                    <h1>ラーニングコモンズ6</h1>
                );
                break;

            case "3":
            case 3:
                floorPath = process.env.PUBLIC_URL + '/svg/daikoudai/oit_building5_7fb.svg';
                title = (
                    <h1>ラーニングコモンズ6 セミナー</h1>
                );
                break;

            default:
                floorPath = process.env.PUBLIC_URL + '/svg/daikoudai/oit_building5_5f.svg';
                title = (
                    <h1>ラーニングコモンズ1,2,3,4,5</h1>
                );
                break;
        }
        //追加 2

        this.state = {
            height: calcHeight,
            width: calcWidth,
            currentFloor: 0,
            mapStatus: props.mapStatus.payload,
            mapLabels: props.mapLabels.payload,
            stockStatus: props.stockStatus.payload,
            map_id,
            floorPath,
            title,
            loading: true
        }

    }


    componentWillMount() {
        this.props.getStatus();
    }

    componentWillUnMount() {
        window.removeEventListener('resize', this.resizeMap);

    }

    componentDidMount() {
        window.addEventListener('resize', this.resizeMap);
        //マップのサイジング
        this.resizeMap();
    }


    // マップオブジェクトのリサイズ
    resizeMap = () => {
        // Windowの高さと横幅を取得してヘッダ分を差し引く
        let calcWidth = window.innerWidth;
        let calcHeight = window.innerHeight - 100;
        // console.log("Width : " + calcWidth + "  height : " + calcHeight);

        this.setState({
            mapWidth: calcWidth,
            mapHeight: calcHeight
        })

    }

    componentWillReceiveProps(nextProps) {
        log.debug(nextProps.location);
        if (this.props.location.search !== nextProps.location.search) {
            this.setState({
                    loading: true
                }, () => this.props.getStatus()
            );
            const query = queryString.parse(this.props.location.search);
            let map_id = "1";
            if (query.map_id) {
                if (query.map_id !== "1" && query.map_id !== "2" && query.map_id !== "3") {
                    this.props.history.push(`${process.env.PUBLIC_URL}/?map_id=1`);
                } else {
                    map_id = query.map_id;
                }
            } else {
                this.props.history.push(`${process.env.PUBLIC_URL}/?map_id=1`);
            }
            //追加 1
            let calcWidth = window.innerWidth;
            let calcHeight = window.innerHeight - 100;
            let floorPath = "";
            let title = "";

            //追加 2
            switch (map_id) {

                case "1":
                case 1:
                    floorPath = process.env.PUBLIC_URL + '/svg/daikoudai/oit_building5_5f.svg';
                    title = (
                        <h1>ラーニングコモンズ1,2,3,4,5</h1>
                    );
                    break;
                case "2":
                case 2:
                    floorPath = process.env.PUBLIC_URL + '/svg/daikoudai/oit_building5_7fa.svg';
                    title = (
                        <h1>ラーニングコモンズ6</h1>
                    );
                    break;

                case "3":
                case 3:
                    floorPath = process.env.PUBLIC_URL + '/svg/daikoudai/oit_building5_7fb.svg';
                    title = (
                        <h1>ラーニングコモンズ6 セミナー</h1>
                    );
                    break;

                default:
                    floorPath = process.env.PUBLIC_URL + '/svg/daikoudai/oit_building5_5f.svg';
                    title = (
                        <h1>ラーニングコモンズ1,2,3,4,5</h1>
                    );
                    break;
            }
            this.setState({
                floorPath,
                title,
                calcHeight,
                calcWidth,
                map_id
            });
        }

        if (this.props.mapStatusConnection !== nextProps.mapStatusConnection) {
            if (nextProps.mapStatusConnection.meta.status === Actions.statusEnum.SUCCESS) {
                this.setState({
                    loading: false
                })
            } else if (nextProps.mapStatusConnection.meta.status === Actions.statusEnum.ERROR) {
                this.setState({
                    showError: true,
                    loading: false
                })
            }
        }

        if (this.props.mapStatus !== nextProps.mapStatus) {
            this.setState({
                mapStatus: nextProps.mapStatus.payload
            })
        }
        if (this.props.mapLabels !== nextProps.mapLabels) {
            this.setState({
                mapLabels: nextProps.mapLabels.payload
            })
        }
        if (this.props.stockStatus !== nextProps.stockStatus) {
            this.setState({
                stockStatus: nextProps.stockStatus.payload
            })
        }
    }

    handleSvgLoaded = () => {
        let mapStatusObject = this.state.mapStatus;
        for (const currentValue in this.state.mapStatus) {
            let generateId = "reserve_" + currentValue;
            if (document.getElementById(generateId)) {
                let list = document.getElementById(generateId);
                let status_class;
                switch (mapStatusObject[currentValue]) {
                    case 1:
                        status_class = "status-available";
                        break;
                    case 2:
                        status_class = "status-commingsoon";
                        break;
                    case 3:
                        status_class = "status-full";
                        break;
                    case 4:
                        status_class = "status-unavailable";
                        break;
                    default:
                        status_class = "status-available";
                        break;
                }
                const newClassName = `${list.getAttribute("class")} ${status_class}`;
                list.setAttribute('class', newClassName)
            }
        }
    };

    changeFloorMap = () => {
        let num = Number(this.state.map_id);
        if (num < 3) {
            num = num + 1
        } else {
            num = 1;
        }
        log.debug(this.state.map_id)
        log.debug(num);
        this.setState({
            map_id: num
        }, () => {
            window.location.href = `${process.env.PUBLIC_URL}/?map_id=${num}`;
        })
    }


    render() {
        let frontPanel = undefined;
        if (this.state.mapLabels !== {} && this.state.mapLabels.hasOwnProperty(this.state.map_id) && this.state.mapLabels[this.state.map_id].map_status_flag) {
            frontPanel = (
                <div className="front-panel">
                    <div className={"full"}>
                        <p>{this.state.mapLabels[Number(this.state.map_id)].map_status_label}</p>
                    </div>
                </div>
            );
        }
        let childrenComponent = <div/>;
        switch (this.state.map_id) {
            default:
                childrenComponent = (
                    <ReactSVG
                        path={this.state.floorPath}
                        callback={this.handleSvgLoaded}
                        style={{width: this.state.mapWidth, height: this.state.mapHeight}}
                    />)
        }

        return (
            <div className={"app"}>
                <Header
                    logo={true}
                    title={this.state.title}
                />
                <div id={"map"} onClick={
                    () => {
                        //this.changeFloorMap
                    }
                }>
                    <CSSTransitionGroup
                        transitionName="example"
                        transitionAppear={true}
                        transitionAppearTimeout={1000}
                        transitionEnterTimeout={1000}
                        transitionLeaveTimeout={2000}
                        transitionEnter={true}
                        transitionLeave={true}>

                        {this.state.loading ?
                            undefined
                            :
                            childrenComponent
                        }
                    </CSSTransitionGroup>
                    <CSSTransitionGroup
                        transitionName="example"
                        transitionAppear={true}
                        transitionAppearTimeout={1000}
                        transitionEnterTimeout={1000}
                        transitionLeaveTimeout={2000}
                        transitionEnter={true}
                        transitionLeave={true}>
                        {this.state.loading ?
                            undefined
                            :
                            frontPanel
                        }
                    </CSSTransitionGroup>
                    {this.state.loading ?
                        <div className="progress">
                            <div className="sk-folding-cube">
                                <div className="sk-cube1 sk-cube"/>
                                <div className="sk-cube2 sk-cube"/>
                                <div className="sk-cube4 sk-cube"/>
                                <div className="sk-cube3 sk-cube"/>
                            </div>
                        </div> :
                        undefined
                    }

                    {
                        /*
                        <NotificationBanner
                            visible={this.state.showError}
                        />
                        */
                    }
                </div>
            </div>
        );
    }
}


Map.propTypes = {};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Map))



// WEBPACK FOOTER //
// ./src/containers/plugin/daikoudai/Map.js